import type { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';

import type TeamOccupancyParticipantResource from '../types/TeamOccupancyParticipantResource';
import type TeamOccupancyWithParticipantsResource from '../types/TeamOccupancyWithParticipantsResource';

// Reads one member's current-week occupancy out of the team-occupancy collection the Team page
// already fetches.
//
// The team has to be matched by `team_id` rather than taken as `items[0]`: the endpoint takes a
// list of team IDs, so position carries no meaning, and reading the wrong team's row would be
// invisible on screen — it would just be a plausible-looking number for the wrong people.
//
// `null` means "nothing to show", and every one of its causes is ordinary: the store has not
// answered yet, this team is not in the answer, the backend is older than this frontend and sends
// no `participants` at all, or the member was added after the response was computed.
const findTeamOccupancyParticipant = (
    teamOccupancy: CollectionResource<TeamOccupancyWithParticipantsResource, {}> | null,
    teamId: ID,
    userId: ID
): TeamOccupancyParticipantResource | null => {
    if (!teamOccupancy) {
        return null;
    }

    const team = teamOccupancy.items.find((item) => item.team_id === teamId);
    if (!team || !team.participants) {
        return null;
    }

    return team.participants.find((participant) => participant.user_id === userId) ?? null;
};

export default findTeamOccupancyParticipant;
